module.exports = "/static/media/applicants_icon.af759383.svg";